module.exports = __webpack_public_path__ + "img/expenses-empty-image.c037762c.png";